// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "additional-2vcnH";
var _4 = "item-12rno";
var _5 = "voucher-ovoxH";
var _6 = "vouchers-22xch";
var _7 = "vouchers__title-2QrpP";
var _8 = "separator-2hogQ";
var _9 = "miles-1UiQx";
export { _1 as "__esModule", _2 as "mobile", _3 as "additional", _4 as "item", _5 as "voucher", _6 as "vouchers", _7 as "vouchers__title", _8 as "separator", _9 as "miles" }
export default { "__esModule": _1, "mobile": _2, "additional": _3, "item": _4, "voucher": _5, "vouchers": _6, "vouchers__title": _7, "separator": _8, "miles": _9 }
